// The purpose of this file is store form field constraints (rules, messages) for a HTML form.
// Note that this data is kept separate from the implementation of the system that stores and retrieves data,
// which is located in the 'core' directory.

// Grab a reference to the application data store object.
var dataStore = app.data;

// Default file types and sizes
var enterSaveConstraintsValidExtensions = ['jpeg', 'jpg', 'png'];
var enterSaveConstraintsMaxFileSize = 5; // 5MB

// Create data and store it. Note that validation messages should be overriden by the server
// in the cshtml view files, to cater for different languages. The message values here are just fallbacks.
// Things should take the format of: fieldName[validatorType] = { message: "My custom message" } as per https://validatejs.org/

dataStore.set('validation.enterFormSaveDraft', {
    projectName: [
        {
            type: 'present',
            errorCode: 10009
        }
    ],
    teamMembers: [
        {
            type: 'present',
            severity: 'ignored'
        },
        {
            type: 'email',
            severity: 'ignored'
        },
        {
            type: 'minItems',
            severity: 'ignored',
            params: {
                size: 1
            }
        },
        {
            type: 'inArray',
            severity: 'warning',
            params: {
                allowedValues: [] // Set via AJAX during lifecycle of application
            }
        },
        {
            type: 'unique',
            severity: 'warning',
            errorCode: 10092
        },
        {
            type: 'notEqualToField',
            severity: 'warning',
            params: {
                comparatorFieldId: 'lead-team-member-input'
            },
            errorCode: 10093
        }
    ],
    'imageCaption-1': [
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-1' },
            errorCode: 10090
        }
    ],
    'imageCaption-2': [
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-2' },
            errorCode: 10090
        }
    ],
    'imageCaption-3': [
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-3' },
            errorCode: 10090
        }
    ],
    'imageCaption-4': [
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-4' },
            errorCode: 10090
        }
    ],
    'imageCaption-5': [
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-5' },
            errorCode: 10090
        }
    ],
    'imageCaption-1-AlternateLanguage': [
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-1' },
            errorCode: 10091,
            severity: 'ignored'
        }
    ],
    'imageCaption-2-AlternateLanguage': [
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-2' },
            errorCode: 10091,
            severity: 'ignored'
        }
    ],
    'imageCaption-3-AlternateLanguage': [
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-3' },
            errorCode: 10091,
            severity: 'ignored'
        }
    ],
    'imageCaption-4-AlternateLanguage': [
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-4' },
            errorCode: 10091,
            severity: 'ignored'
        }
    ],
    'imageCaption-5-AlternateLanguage': [
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-5' },
            errorCode: 10091,
            severity: 'ignored'
        }
    ],
    'imageFile-1': [
        {
            type: 'fileType',
            params: { validExtensions: enterSaveConstraintsValidExtensions },
            errorCode: 10032
        },
        {
            type: 'maxFileSize',
            params: { size: enterSaveConstraintsMaxFileSize },
            errorCode: 10033
        }
    ],
    'imageFile-2': [
        {
            type: 'fileType',
            params: { validExtensions: enterSaveConstraintsValidExtensions },
            errorCode: 10032
        },
        {
            type: 'maxFileSize',
            params: { size: enterSaveConstraintsMaxFileSize },
            errorCode: 10033
        }
    ],
    'imageFile-3': [
        {
            type: 'fileType',
            params: { validExtensions: enterSaveConstraintsValidExtensions },
            errorCode: 10032
        },
        {
            type: 'maxFileSize',
            params: { size: enterSaveConstraintsMaxFileSize },
            errorCode: 10033
        }
    ],
    'imageFile-4': [
        {
            type: 'fileType',
            params: { validExtensions: enterSaveConstraintsValidExtensions },
            errorCode: 10032
        },
        {
            type: 'maxFileSize',
            params: { size: enterSaveConstraintsMaxFileSize },
            errorCode: 10033
        }
    ],
    'imageFile-5': [
        {
            type: 'fileType',
            params: { validExtensions: enterSaveConstraintsValidExtensions },
            errorCode: 10032
        },
        {
            type: 'maxFileSize',
            params: { size: enterSaveConstraintsMaxFileSize },
            errorCode: 10033
        }
    ]
});
